import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { ChangeBestellmengenDialogComponent } from '../../../wa-wi/bestellvorschlaege/change-bestellmengen-dialog/change-bestellmengen-dialog.component';
import { GoodsReceiptHistory } from '../goods-receipt-history.component';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-correct-amount-dialog',
    templateUrl: './correct-amount-dialog.component.html',
    styleUrls: ['./correct-amount-dialog.component.scss'],
})
export class CorrectAmountDialogComponent implements OnInit {
    wareneingangshistorie: GoodsReceiptHistory;
    amountCtrl = new UntypedFormControl();

    constructor(
        public dialogRef: MatDialogRef<ChangeBestellmengenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private messageService: MessageService,
    ) {
        this.wareneingangshistorie = data.grh;
    }

    ngOnInit() {
        this.amountCtrl.setValue(this.wareneingangshistorie.menge);
    }

    cancel() {
        this.dialogRef.close(false);
    }

    save() {
        const updateObject = {
            umbuchung_id: this.wareneingangshistorie.umbuchung_id,
            menge_neu: this.amountCtrl.value,
        };

        this.api.updateGeneric(this.apiBaseUrl + 'wareneingang/update.php', updateObject).subscribe(
            () => {
                this.messageService.infoMessage('Die Menge wurde erfolgreich korrigiert!');
                this.dialogRef.close(true);
            },
            error => {
                this.messageService.errorMessage('Fehler beim Korrigieren aufgetreten!', error);
                this.dialogRef.close(false);
            },
        );
    }
}
